/** HTML de impressão de atestado — mesmo contrato que `Certificates.tsx` (GET .../print). */
import { CLINIC_DOC_SIGNATURE_CSS } from './clinicPrintLetterhead';

const typeLabels: Record<string, string> = {
  medical_leave: 'Atestado Médico',
  attendance: 'Declaração de Comparecimento',
  fit_to_work: 'Aptidão ao Trabalho',
  accompaniment: 'Acompanhante',
  custom: 'Personalizado',
};

export function buildCertificatePrintHtml(printData: any): string {
  const cert = printData.certificate;
  const clinic = printData.clinic;
  const patient = cert?.patient || cert?.patient_snapshot || {};
  const prof = cert?.professional || cert?.professional_snapshot || {};
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Atestado</title>
<style>body{font-family:Arial,sans-serif;max-width:700px;margin:0 auto;padding:40px;color:#333}
.header{text-align:center;border-bottom:2px solid #14B8A6;padding-bottom:20px;margin-bottom:30px}
.clinic-name{font-size:22px;font-weight:bold;color:#14B8A6} .clinic-info{font-size:12px;color:#666;margin-top:5px}
.title{text-align:center;font-size:20px;font-weight:bold;margin:30px 0;text-transform:uppercase}
.content{font-size:14px;line-height:2;text-align:justify;margin:20px 0}
.info{font-size:13px;margin:5px 0} .info strong{color:#14B8A6}
${CLINIC_DOC_SIGNATURE_CSS}
.cert-print-footer{margin-top:28px;text-align:center;border-top:1px solid #ddd;padding-top:16px;font-size:11px;color:#666}
@media print{body{padding:20px}}</style></head><body>
<div class="header"><div class="clinic-name">${clinic?.clinic_name || 'Clínica'}</div>
<div class="clinic-info">${clinic?.clinic_address || ''}<br/>${clinic?.clinic_phone || ''} | ${clinic?.clinic_email || ''}</div></div>
<div class="title">${cert?.title || typeLabels[cert?.certificate_type] || 'Atestado'}</div>
<div class="info"><strong>Paciente:</strong> ${patient?.full_name || 'N/A'}</div>
${patient?.cpf ? `<div class="info"><strong>CPF:</strong> ${patient.cpf}</div>` : ''}
<div class="info"><strong>Data:</strong> ${cert?.issue_date ? new Date(cert.issue_date + 'T12:00:00').toLocaleDateString('pt-BR') : ''}</div>
${cert?.days_off || cert?.leave_days ? `<div class="info"><strong>Período de afastamento:</strong> ${cert.days_off || cert.leave_days} dia(s)</div>` : ''}
${cert?.start_date || cert?.leave_start_date ? `<div class="info"><strong>De:</strong> ${new Date((cert.start_date || cert.leave_start_date) + 'T12:00:00').toLocaleDateString('pt-BR')} <strong>Até:</strong> ${cert?.end_date || cert?.leave_end_date ? new Date((cert.end_date || cert.leave_end_date) + 'T12:00:00').toLocaleDateString('pt-BR') : ''}</div>` : ''}
${cert?.cid_code || cert?.diagnosis_code ? `<div class="info"><strong>CID:</strong> ${cert.cid_code || cert.diagnosis_code} - ${cert.cid_description || cert.diagnosis || ''}</div>` : ''}
<div class="content">${(cert?.content || '').replace(/\n/g, '<br/>')}</div>
<div class="clinic-doc-sign-zone clinic-doc-sign-zone--compact">
  <div class="clinic-doc-sign-row">
    <div class="clinic-doc-sign-slot">
      <div class="clinic-doc-sign-spacer"></div>
      <div class="clinic-doc-sign-rule"></div>
      <p class="clinic-doc-sign-caption">${prof?.full_name || ''}</p>
      <p class="clinic-doc-sign-caption">${prof?.registration_type || 'CRM'} ${prof?.registration_number || ''}${prof?.registration_state ? ` - ${prof.registration_state}` : ''}</p>
      ${prof?.specialty ? `<p class="clinic-doc-sign-caption">${prof.specialty}</p>` : ''}
    </div>
    <div class="clinic-doc-sign-slot clinic-doc-sign-slot--narrow">
      <div class="clinic-doc-sign-spacer"></div>
      <div class="clinic-doc-sign-rule"></div>
      <p class="clinic-doc-sign-caption">Data: ___/___/______</p>
    </div>
  </div>
</div>
<div class="cert-print-footer">${clinic?.clinic_name || ''} - ${new Date().toLocaleDateString('pt-BR')}</div>
</body></html>`;
}
